import { createStyles } from "antd-style";
export const adminUserLogsStyles = createStyles(({ css }) => ({
  "ant-pagination-over-ride": {
    ".ant-pagination-item-active": css`
      background-color: transparent !important;
    `
  }
}));
